import { Separator } from "@/components/ui/separator";

const LOGO = "/logo.jpeg";

const linkGroups = {
  Solutions: ["Ojas Vani", "Ojas Krishi", "Ojas Arogya", "Ojas Raksha"],
  Company: ["About", "Careers", "Contact", "Blog"],
  Legal: ["Privacy Policy", "Terms of Service", "Compliance"],
};

export const FooterSection = () => (
  <footer data-testid="footer" className="py-16 relative border-t border-border">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12">
        <div className="lg:col-span-2">
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO} alt="Ojas AI" className="h-10 w-10 rounded-md" />
            <span className="font-heading font-semibold text-lg text-foreground">
              OJAS <span className="text-[#c9a84c]">AI</span>
            </span>
          </div>
          <p className="font-body text-muted-foreground text-sm leading-relaxed max-w-sm">
            Ojas AI is committed to building secure, sovereign, and ethical AI
            systems that empower industries while protecting data, privacy, and
            national interests.
          </p>
          <div className="mt-4 space-y-1">
            <p className="font-body text-muted-foreground text-xs">info@ojas-ai.in</p>
            <p className="font-body text-muted-foreground text-xs">contact@ojas-ai.in</p>
          </div>
        </div>

        {Object.entries(linkGroups).map(([title, items]) => (
          <div key={title}>
            <h4 className="font-heading font-semibold text-foreground text-sm mb-4">{title}</h4>
            <ul className="space-y-2.5">
              {items.map((item) => (
                <li key={item}>
                  <button className="font-body text-muted-foreground text-sm hover:text-[#c9a84c] transition-colors duration-200">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <Separator className="my-10 bg-border" />

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="font-body text-muted-foreground text-xs">
          &copy; {new Date().getFullYear()} Ojas AI (formerly Ojas Innovations).
          All rights reserved.
        </p>
        <p className="font-body text-muted-foreground text-xs">
          Bengaluru &middot; India
        </p>
      </div>
    </div>
  </footer>
);
